module.exports = __webpack_public_path__ + "img/template2.be7e8672.svg";